const state = {
  candidateDetails: {},
  candidateDossierDetails: {},
  closeupDetails: {},
  isCloseup: false,
  closeupCount: 0,
  candidateInfo: null
}
export default state
